import { commonApiClient } from '../../../util/apiClient/commonApiClient'
import { IConsumePlayerResponse } from './ConsumePlayerResponse'

export interface IConsumePlayerApi {
  consumeToken: (token: string) => Promise<string>
}

export const consumePlayerApi: IConsumePlayerApi = {
  async consumeToken(sessionToken: string): Promise<string> {
    const res = await commonApiClient.post<IConsumePlayerResponse>(`/ConsumePlayer`, {
      sessionToken,
      ipAddress: '',
    })
    return res.data.authToken
  },
}

export const mockConsumePlayerApi: IConsumePlayerApi = {
  async consumeToken(): Promise<string> {
    return 'mockedAuthToken'
  },
}
